<div class="container">
    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header class="headerWithAccentButton">
                    <mat-card-title>Basisinformationen</mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="addForm">
                    <div class="row marginBottom2Rem" *ngIf="this.changeImage">
                        <div class="col-sm-12">
                            <div ngx-dropzone [accept]="'image/jpeg,image/jpg,image/png'" (change)="onSelect($event)"
                                [multiple]="false">
                                <ngx-dropzone-label>
                                    <div>
                                        <h3>Bild hierher ziehen</h3>
                                        <h5>ODER</h5>
                                        <button mat-raised-button color="accent">Durchsuchen</button>
                                    </div>
                                </ngx-dropzone-label>
                                <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files"
                                    [file]="f" [removable]="true" (removed)="onRemove(f)">
                                </ngx-dropzone-image-preview>
                            </div>
                            <mat-hint>
                                Empfohlene Auflösung: 1500 x 938 px
                            </mat-hint>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="centerVerticalAndHoritontal actionRow">
                                <img class="img-responsive img-clickable" src="{{this.addForm.value?.image.url}}"
                                    alt="">
                            </div>
                            <mat-error
                                *ngIf="this.addForm.controls.image.touched && this.addForm.controls.image.hasError('required')">
                                Das Bild <strong>muss</strong> angegeben werden
                            </mat-error>

                            <div *ngFor="let p of imageProperties"
                                class="centerVerticalAndHoritontal marginTop2Rem marginBottom2Rem">
                                <button mat-raised-button color="accent" (click)="openImageGallery(p)">
                                    Bild auswählen</button>
                                <button mat-raised-button color="primary" (click)="toogleImageUpload()"
                                    class="margrinLeftBtn">Bild hochladen</button>
                                <!-- <button mat-raised-button color="primary" class="margrinLeftBtn"
                                    (click)="openStockImageGallery()">Stock Bild
                                    herunterladen</button> -->
                            </div>
                        </div>
                    </div>

                    <div class="row ">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Vorteilstyp</mat-label>
                                <mat-select formControlName="eventDiscount" (selectionChange)="changeEvenType()">
                                    <mat-option *ngFor="let sortOption of eventStates" [value]="sortOption.value"
                                        [disabled]="sortOption.state">
                                        {{sortOption.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error>
                                    Vorteilstyp <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                    <div class="row ">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Partner</mat-label>
                                <mat-select formControlName="eventPartner">
                                    <mat-option *ngFor="let partner of partners" [value]="partner">
                                        {{partner?.name}}
                                    </mat-option>
                                </mat-select>
                                <mat-error>
                                    Der Partner <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Titel:</mat-label>
                                <input matInput formControlName="title">
                                <mat-error *ngIf="addForm.get('title').hasError('required')">
                                    Titel <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- [ngClass]="{'marginBottom2Rem': this.addForm.value.eventDiscount != 'MONETARY'}" -->
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Aktionsstatus</mat-label>
                                <mat-select formControlName="state">
                                    <mat-option *ngFor="let state of this.event_States" [value]="state.value">
                                        {{state.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error>
                                    Der Aktionsstatus <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row "
                        [ngClass]="{'marginBottom2Rem': this.addForm.getRawValue().eventDiscount != 'MONETARY'}">
                        <div class="col-sm-12">
                            <mat-checkbox formControlName="autoStatus">
                                <span style="display: flex;align-items: center;">Automatischer Statuswechsel
                                    <mat-icon aria-hidden="false" fontIcon="info" style="margin-left: 10px;"
                                        (click)="showEventStateModal()"></mat-icon>
                                </span>
                            </mat-checkbox>


                        </div>
                        <div class="col-sm-12">
                            <mat-checkbox formControlName="cancelable">
                                <span>Aktion ist stornierbar</span>
                            </mat-checkbox>
                        </div>
                    </div>


                    <div class="row" *ngIf="this.addForm.value.state === 'HIDDEN'">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Zugangscode:</mat-label>
                                <input matInput formControlName="accessCode">
                                <mat-hint>Kunden, welche diesen Zugangscode eingeben haben Zugriff auf die
                                    Aktion</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row marginTop2Rem" *ngIf="this.addForm.getRawValue().eventDiscount == 'MONETARY'">
                        <div class="col-sm-12" [formGroup]="priceForm">
                            <mat-radio-group aria-label="Select an option" formControlName="type"
                                (change)="changeDiscountType()">
                                <mat-radio-button value="1">Preisvorteil in Euro</mat-radio-button>
                                <mat-radio-button value="2">Preisvorteil in Prozent</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="row marginBottom2Rem"
                        *ngIf="this.priceForm.value.type == '1' && this.addForm.getRawValue().eventDiscount == 'MONETARY' ">
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Ursprungspreis:</mat-label>
                                <input matInput type="number" formControlName="regularPriceMoney">
                                <mat-hint>
                                    Der Ursprungspreis der Aktion
                                </mat-hint>
                                <mat-error *ngIf="addForm.get('regularPriceMoney').hasError('required')">
                                    Ursprungspreis <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Reduzierter Preis:</mat-label>
                                <input matInput type="number" formControlName="eventPriceMoney">
                                <mat-hint>
                                    Der reduzierte Preis der Aktion
                                </mat-hint>
                                <mat-error *ngIf="addForm.get('eventPriceMoney').hasError('required')">
                                    Der reduzierte Preis <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row marginBottom2Rem"
                        *ngIf="this.priceForm.value.type == '2' && this.addForm.getRawValue().eventDiscount == 'MONETARY'">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Reduzierung in Prozent:*</mat-label>
                                <input matInput type="number" formControlName="savingInPercent">
                                <mat-hint *ngIf="addForm.get('savingInPercent').hasError('required')">
                                    Die Reduzierung <strong>muss</strong> angegeben werden
                                </mat-hint>
                                <mat-hint *ngIf="addForm.get('savingInPercent').hasError('max')">
                                    Die Reduzierung <strong>darf</strong> maximal 100% sein
                                </mat-hint>
                            </mat-form-field>
                        </div>
                    </div>

                    @if (this.usesPayPal) {
                    <div class="row marginBottom2Rem" *ngIf="this.addForm.getRawValue().eventDiscount == 'MONETARY'">
                        <div class="col-sm-12">
                            <mat-checkbox formControlName="paymentRequired">
                                <span>Bezahlpflichtige Aktion</span>
                            </mat-checkbox>


                        </div>

                        <div class="col-sm-12 marginTop2Rem" *ngIf="this.addForm.getRawValue().paymentRequired == true">
                            <mat-form-field class="full-width">
                                <mat-label>Mehrwertsteuer</mat-label>
                                <mat-select formControlName="taxRate">
                                    <mat-option *ngFor="let taxRate of taxesRates" [value]="taxRate.value">
                                        {{taxRate?.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    }

                    <ckeditor [editor]="Editor" [config]="config"
                        style="display:inline-block;width: 100%;min-height: 250px;height: 350px;"
                        formControlName="description"></ckeditor>

                    <mat-error style="margin-top: 15px;"
                        *ngIf="this.addForm.controls.description.touched && this.addForm.controls.description?.errors?.required">
                        Vorteilsbeschreibung <strong>muss</strong> angegeben werden
                    </mat-error>

                    <button mat-raised-button color="primary" (click)="showAsHtml = !showAsHtml">Als HTML
                        anzeigen</button>

                    <div class="row marginTop2Rem" *ngIf="showAsHtml">
                        <div class="col-lg-12">
                            <mat-form-field class="full-width">
                                <mat-label>Vorteilsbeschreibung (HTML):</mat-label>
                                <textarea matInput formControlName="description" rows="20" cols="80"></textarea>
                                <mat-error *ngIf="addForm.get('description').hasError('required')">
                                    Vorteilsbeschreibung <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>


                    <div class="row  marginBottom2Rem" [formGroup]="interestForm">
                        <div class="col-sm-12">
                            <mat-card-title>Kategorien</mat-card-title>
                            <div class="row" formGroupName="interests">
                                <div class="col-sm-4"
                                    *ngFor="let interestCheckbox of interestCheckboxOptions; let i=index">
                                    <label>
                                        <mat-checkbox class="example-margin" [value]="interestCheckbox"
                                            (change)="onCheckboxChange($event)">
                                            {{interestCheckbox.name}}
                                        </mat-checkbox>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row  marginBottom2Rem marginTop2Rem" *ngIf="showCustomerValues">
                        <mat-card-title>Kudenwert</mat-card-title>
                        <mat-form-field appearance="fill" class="full-width" appearance="outline">
                            <mat-select formControlName="customerValues" multiple>
                                <mat-option *ngFor="let state of clubstates"
                                    [value]="state.shortcode">{{state.longname}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="addForm.get('customerValues').hasError('required')">
                                Kudenwert <strong>muss</strong> angegeben werden
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <br>
                    <mat-card-actions align="end" *ngIf="this.type == 'minimal' ">
                        <button mat-button color="primary" (click)="movebacktoOverview()"> Abbrechen</button>
                        <button mat-button color="primary" (click)="createEvent()">Aktion anlegen</button>
                    </mat-card-actions>
                </mat-card-content>
            </mat-card>

            <mat-card *ngIf="this.type == 'advanced'" class="marginTop2Rem">
                <mat-card-header>
                    <mat-card-title>
                        Aktionszeitraum
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="dateForm">
                    <mat-form-field appearance="fill" class="full-width" appearance="outline">
                        <mat-label>Aktionszeitraum:</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate placeholder="Startdatum" formControlName="startDate" format>
                            <input matEndDate placeholder="Enddatum" formControlName="endDate">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                        <mat-error
                            *ngIf="this.dateForm.controls.endDate.touched && this.dateForm.controls.endDate.hasError('required')">
                            Die Aktionszeitraum <strong>muss</strong> angegeben werden
                        </mat-error>
                    </mat-form-field>

                </mat-card-content>
            </mat-card>


            <mat-card appearance="outlined" class="marginTop2Rem" *ngIf="this.type == 'advanced'" id="address">
                <mat-card-header>
                    <mat-card-title>Anschrift</mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="addressForm">
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width" appearance="fill">
                                <mat-label>Straße + Hausnummer:</mat-label>
                                <input matInput type="text" formControlName="street">
                                <mat-error *ngIf="addressForm.get('street').hasError('required')">
                                    Straße + Hausnummer <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width" appearance="fill">
                                <mat-label>PLZ:</mat-label>
                                <input matInput type="text" formControlName="postcode">
                                <mat-error *ngIf="addressForm.get('postcode').hasError('required')">
                                    PLZ <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width" appearance="fill">
                                <mat-label>Ort:</mat-label>
                                <input matInput type="text" formControlName="city">
                                <mat-error *ngIf="addressForm.get('city').hasError('required')">
                                    Ort <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>

            <mat-card appearance="outlined" *ngIf="this.type == 'advanced'" class="marginTop2Rem"
                [formGroup]="limitationForm">
                <mat-card-header>
                    <mat-card-title>
                        Kontingent begrenzen
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <mat-form-field class="full-width">
                        <mat-label>Gesamt (0 - keine Begrenzung):</mat-label>
                        <input matInput formControlName="reservationQuota">
                    </mat-form-field>
                    <mat-form-field class="full-width">
                        <mat-label>Pro Person (0 - keine Begrenzung):</mat-label>
                        <input matInput formControlName="perPersonQuota">
                    </mat-form-field>
                    <mat-form-field class="full-width">
                        <mat-label>Pro Haushalt (0 - keine Begrenzung):</mat-label>
                        <input matInput formControlName="groupQuota">
                    </mat-form-field>

                </mat-card-content>
            </mat-card>


            <mat-card appearance="outlined" *ngIf="this.type == 'advanced'" class="marginTop2Rem"
                [formGroup]="voucherCreationForm">
                <mat-card-header>
                    <mat-card-title>
                        Gutscheinerzeugung
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="row">
                        <div class="col-lg-12">
                            <mat-radio-group formControlName="validityPeriod" (change)="changeVoucherTime($event)">
                                <mat-radio-button value='true'>Gültigkeitsdauer in Tagen</mat-radio-button>
                                <mat-radio-button value='false'>Gültigkeit bis...</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="row" *ngIf="this.voucherCreationForm?.controls['validityPeriod'].value == 'true'">
                        <div class="col-lg-12">
                            <mat-form-field class="full-width">
                                <mat-label>Gültigkeitsdauer in Tagen:</mat-label>
                                <input matInput formControlName="reservationValidTime">
                                <mat-hint>Wie lange soll die Aktion nutzbar sein?</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-12"
                            *ngIf="this.voucherCreationForm?.controls['validityPeriod'].value == 'false'">
                            <mat-form-field class="full-width">
                                <mat-label>
                                    Gültigkeit bis</mat-label>
                                <input matInput formControlName="validityDate" type="date">
                            </mat-form-field>
                        </div>
                    </div>


                    <div class="row ">
                        <div class="col-lg-12">
                            <mat-form-field class="full-width">
                                <mat-label>Gutscheincodes</mat-label>
                                <mat-select formControlName="voucherKeyStrategy">
                                    <mat-option *ngFor="let sortOption of voucherOptions" [value]="sortOption.value"
                                        [disabled]="sortOption.state">
                                        {{sortOption.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-hint>Wer stellt die Gutscheincodes zur Verfügung?</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>
                    <br>

                    @if (this.addForm.getRawValue().eventDiscount != "RAFFLE" ) {
                    <div class="row">
                        <div class="col-lg-12">
                            <mat-checkbox formControlName="autoAttendance">
                                <span [innerHtml]="'Gutschein automatisch einlösen'"></span>
                            </mat-checkbox>
                        </div>
                    </div>
                    }
                    <div class="row">
                        <div class="col-lg-12">
                            <mat-checkbox formControlName="sendStornoMail">
                                <span [innerHtml]="'Stornierungsmail/Benachrichtigung senden'"></span>
                            </mat-checkbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <mat-checkbox formControlName="showReservationQR">
                                <span [innerHtml]="'QR Code in Mail/Portal anzeigen'"></span>
                            </mat-checkbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <mat-checkbox formControlName="sendReservationMail">
                                <span [innerHtml]="'Reservierungsbestätigung senden'"></span>
                            </mat-checkbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <mat-form-field class="full-width">
                                <mat-label>Reservierungshinweis:</mat-label>
                                <textarea matInput formControlName="reservationClue"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>

            <mat-card appearance="outlined" *ngIf="this.type == 'advanced'" class="marginTop2Rem"
                [formGroup]="detailsForm">
                <mat-card-header>
                    <mat-card-title>
                        Details
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="row">
                        <div class="col-lg-12">
                            <mat-form-field class="full-width">
                                <mat-label>Termindetails:</mat-label>
                                <input matInput formControlName="scheduleDescription">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row ">
                        <div class="col-lg-12">
                            <mat-form-field class="full-width">
                                <mat-label>Ort / Adresse::</mat-label>
                                <input matInput formControlName="location">
                                <mat-hint>Bitte nutzen Sie die Felder unter dem Punkt <a (click)="jumpToAddress()"
                                        style="color: #0d6efd !important;">Anschrift</a></mat-hint>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <mat-form-field class="full-width">
                                <mat-label>Zieladresse (falls als Werbefläche genutzt):</mat-label>
                                <input matInput formControlName="additionalInformationWebsite">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <mat-form-field class="full-width">
                                <mat-label>Zielgruppe</mat-label>
                                <mat-select formControlName="eventLimit">
                                    <mat-option *ngFor="let sortOption of targetGroupOptions" [value]="sortOption.value"
                                        [disabled]="sortOption.state">
                                        {{sortOption.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <mat-form-field class="full-width">
                                <mat-label>Priorität</mat-label>
                                <mat-select formControlName="priority">
                                    <mat-option *ngFor="let sortOption of prioOptions" [value]="sortOption.value"
                                        [disabled]="sortOption.state">
                                        {{sortOption.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                </mat-card-content>
                <!-- <mat-card-actions align="end" *ngIf="this.type == 'advanced' ">
                    <button mat-button color="primary" (click)="movebacktoOverview()"> Abbrechen</button>
                    <button mat-button color="primary" (click)="createEvent()">Aktion anlegen</button>
                </mat-card-actions> -->
            </mat-card>

            <mat-card appearance="outlined" *ngIf="this.type == 'advanced'" class="marginTop2Rem"
                [formGroup]="buttonConfigForm">
                <mat-card-header>
                    <mat-card-title>
                        Button
                    </mat-card-title>
                    <mat-card-subtitle>
                        Mit dieser Einstellung kann eine Aktion zur Verlinkung auf eine externe Webseite genutzt werden.
                        Falls ein Link hinerlegt wird ist damit keine Reservierung der Aktion mehr möglich.
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <div class="row">
                        <div class="col-lg-12">
                            <mat-form-field class="full-width">
                                <mat-label>Buttontext:</mat-label>
                                <input matInput formControlName="buttonCaption">
                                <!-- <mat-hint><strong>Der Text der auf dem Button angezeigt wird (Wird nur angezeigt, falls
                                        der auch der Link, der geöffnet werden soll hinterlegt ist)</strong></mat-hint> -->
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-12">
                            <mat-form-field class="full-width">
                                <mat-label>Link:</mat-label>
                                <input matInput formControlName="buttonExternalLink">
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
                <mat-card-actions align="end" *ngIf="this.type == 'advanced' ">
                    <button mat-button color="primary" (click)="movebacktoOverview()"> Abbrechen</button>
                    <button mat-button color="primary" (click)="createEvent()">Aktion anlegen</button>
                </mat-card-actions>
            </mat-card>


            <mat-card appearance="outlined" class="example-card marginTop2Rem marginBottom2Rem">
                <mat-card-header>
                    <mat-card-title>Vorschau</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="row">
                        <div class="col-sm-12 col-lg-6 VTWPreview">
                            <div class="lio-card">
                                <div class="preview-img">
                                    <!-- <div #img class="img-background-cover full"></div> -->
                                    <img *ngIf="this.addForm.value.image" class="img-background-cover full"
                                        src="{{this.addForm.value.image.url}}" alt="">
                                    <img *ngIf="!this.addForm.value.image" class="img-background-cover full"
                                        src="../../../../../../assets//placeholders/eventImage.png" alt="">

                                </div>
                                <div class="background-white">
                                    <div class="content inner-margin">
                                        <div *ngIf="this.addForm.value.eventDiscount != 'RAFFLE'">
                                            <div class="additional-info highlight"
                                                *ngIf="(this.addForm.value?.eventDiscount !='SERVICE_PLUS')">
                                                {{addForm.value?.discountLabel ? '' : 'Ihr Preisvorteil'}}</div>

                                            <div class="additional-info highlight"
                                                *ngIf="(this.addForm.value?.eventDiscount =='SERVICE_PLUS')">
                                                Exklusiver Vorteil
                                            </div>
                                        </div>

                                        <div *ngIf="this.addForm.value.eventDiscount == 'RAFFLE'">
                                            <div class="additional-info highlight">
                                                Gewinnspiel
                                            </div>
                                        </div>



                                        <!-- EMPTY STATE IF THE USER HAS NOT PUT IN A DISCOUNTMAOUNT -->
                                        <div class="additional-info highlight"
                                            *ngIf="(this.priceForm.value.type == '2')  && (this.addForm.value.savingInPercent == null)">
                                            Ihr Preisvorteil </div>


                                        <h4 class="minHeight40" *ngIf="this.addForm.value.title">
                                            {{this.addForm.value.title | truncate : 40 : false}}</h4>
                                        <h4 class="minHeight40" *ngIf="!this.addForm.value.title">Der Titel Ihrer
                                            Vorteilsaktion</h4>

                                        <h5 class="additional-info-big">
                                            {{this.dateForm?.getRawValue().startDate | date : 'dd.MM.YYYY'}}
                                            bis
                                            {{this.dateForm?.getRawValue().endDate | date : 'dd.MM.YYYY'}}
                                        </h5>

                                        <h5 class="additional-info" *ngIf="this.addForm.value.eventPartner">
                                            {{this.addForm.value.eventPartner.name | truncate : 30 : true}}</h5>
                                        <h5 class="additional-info" *ngIf="!this.addForm.value.eventPartner">Ihr
                                            Aktionspartner</h5>

                                    </div>
                                    <div
                                        *ngIf="this.buttonConfigForm.getRawValue().buttonExternalLink == '' || this.buttonConfigForm.getRawValue().buttonExternalLink == null ">
                                        <button class="previewBtn" *ngIf="this.addForm.value.eventDiscount != 'RAFFLE'">
                                            Reservieren
                                        </button>
                                        <button class="previewBtn" *ngIf="this.addForm.value.eventDiscount == 'RAFFLE'">
                                            Mitmachen
                                        </button>
                                    </div>

                                    <div
                                        *ngIf="this.buttonConfigForm.getRawValue().buttonExternalLink != '' && this.buttonConfigForm.getRawValue().buttonExternalLink != null ">
                                        <button class="previewBtn">
                                            {{ this.buttonConfigForm.getRawValue().buttonCaption}}
                                        </button>
                                    </div>


                                </div>

                                <div
                                    *ngIf="this.buttonConfigForm.getRawValue().buttonExternalLink != '' && this.buttonConfigForm.getRawValue().buttonExternalLink != null ">
                                    <button class="previewBtn">
                                        {{ this.buttonConfigForm.getRawValue().buttonCaption}}
                                    </button>
                                </div>


                            </div>

                        </div>
                    </div>

                    <div class="col-sm-12 col-lg-6">
                        <div class="device" data-device="iPhoneX" data-orientation="portrait" data-color="black">
                            <div class="screen">

                                <div class="preview-img">
                                    <img *ngIf="this.addForm.value?.image" class="width100 full"
                                        src="{{this.addForm.value?.image.url}}" alt="">
                                    <img *ngIf="!this.addForm.value?.image" class="width100 full"
                                        src="../../../../../../assets//placeholders/eventImage.png" alt="">
                                </div>
                                <div class="header">
                                    <h4 *ngIf="this.addForm.value.title">
                                        {{this.addForm.value.title | truncate : 35 : false}}</h4>
                                    <h4 *ngIf="!this.addForm.value.title">Der Titel Ihrer
                                        Vorteilsaktion</h4>

                                    <img src="../../../../../assets/icons/close.png" class="closeBtn" alt="">
                                </div>

                                <div class="redBox">
                                    <div *ngIf="this.addForm.value.eventDiscount != 'RAFFLE'">
                                        <div class="additional-info highlight"
                                            *ngIf="(this.addForm.value?.eventDiscount !='SERVICE_PLUS')">
                                            {{addForm.value?.discountLabel ? '' : 'Ihr Preisvorteil'}}</div>

                                        <div class="additional-info highlight"
                                            *ngIf="(this.addForm.value?.eventDiscount =='SERVICE_PLUS')">
                                            Exklusiver Vorteil
                                        </div>
                                    </div>

                                    <div *ngIf="this.addForm.value.eventDiscount == 'RAFFLE'">
                                        <div class="additional-info highlight">
                                            Gewinnspiel
                                        </div>
                                    </div>

                                </div>

                                <div class="reservations">
                                    <div class="wrapper">
                                        <div class="minus">
                                            -
                                        </div>

                                        <h3>1</h3>
                                        <div class="plus">
                                            +
                                        </div>

                                        <h3>Max Mustermann</h3>
                                    </div>
                                </div>
                                <div class="divider"></div>

                                <div class="description">
                                    <h6> <b>Vorteilsbeschreibung</b> </h6>
                                    <div [innerHtml]="this.addForm.value?.description">

                                    </div>
                                </div>
                                <div class="actionButton">


                                    <div
                                        *ngIf="this.buttonConfigForm.getRawValue().buttonExternalLink == '' || this.buttonConfigForm.getRawValue().buttonExternalLink == null ">
                                        <div class="btn" *ngIf="this.addForm.value.eventDiscount != 'RAFFLE'">
                                            Reservieren
                                        </div>
                                        <div class="btn" *ngIf="this.addForm.value.eventDiscount == 'RAFFLE'">
                                            Mitmachen
                                        </div>
                                    </div>

                                    <div
                                        *ngIf="this.buttonConfigForm.getRawValue().buttonExternalLink != '' && this.buttonConfigForm.getRawValue().buttonExternalLink != null ">
                                        <div class="btn">
                                            {{ this.buttonConfigForm.getRawValue().buttonCaption}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="button">
                                <!-- <You can hook the "home button" to some JavaScript events or just remove it  -->
                            </div>
                        </div>
                        <div class="button">
                            <!-- <You can hook the "home button" to some JavaScript events or just remove it  -->
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>